<template>
  <q-select
    :value="value"
    v-bind="$attrs"
    label="Type"
    option-value="value"
    option-label="label"
    emit-value
    map-options
    :options="$options.AGENTS_TYPES_LIST"
    v-on="$listeners"
  />
</template>

<script>
import { AGENTS_TYPES_LIST } from '@/consts/agents'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'SelectAgentType',
  mixins: [validateProxyMixin],
  inheritAttrs: false,
  AGENTS_TYPES_LIST,
  props: {
    value: {
      type: [Array, Object, String, Number],
      default: _.stubObject
    }
  }
}
</script>

<style scoped>

</style>
